import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import About from './views/About.vue'
import Fund from './views/Fund.vue'
import SaleFundInfo from './views/SaleFundInfo.vue'
import SaleMemberInfo from './views/SaleMemberInfo.vue'
import SaleCompany from './views/SaleCompany.vue'
import Hotel from './views/Hotel.vue'
import HotelDetail from './views/HotelDetail.vue'
import Travel from './views/Travel.vue'
import Contact from './views/Contact.vue'
import Account from './views/Account.vue'

Vue.use(Router)

export default new Router({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes: [{
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/about',
    name: 'about',
    component: About
  },
  {
    path: '/fund',
    name: 'fund',
    component: Fund
  },
  // 基金圖表
  // {
  //   path: '/fund/:id(\\d+)',
  //   name: 'fundInfo',
  //   component: FundInfo
  // },
  {
    path: '/sale/:id(\\d+)',
    name: 'saleFundInfo',
    component: SaleFundInfo
  },
  // 人員詳細資料
  // {
  //   path: '/fundMemberInfo/:id(\\d+)',
  //   name: 'fundMemberInfo',
  //   component: FundMemberInfo
  // },
  {
    path: '/saleMemberInfo/:id(\\d+)',
    name: 'saleMemberInfo',
    component: SaleMemberInfo
  },
  // 機構詳細資料
  // {
  //   path: '/fundCompany/:id(\\d+)',
  //   name: 'fundCompany',
  //   component: FundCompany
  // },
  {
    path: '/saleCompany/:id(\\d+)',
    name: 'saleCompany',
    component: SaleCompany
  },

  {
    path: '/hotel',
    name: 'hotel',
    component: Hotel
  },
  {
    path: '/hotel_detail',
    name: 'hotelDetail',
    component: HotelDetail
  },
  {
    path: '/travel',
    name: 'travel',
    component: Travel
  },
  {
    path: '/contact',
    name: 'contact',
    component: Contact
  },
  {
    path: '/account',
    name: 'account',
    component: Account
  }
  ],
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 200, behavior: 'smooth' }
  }
})
